"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormulaVariableNotFoundError = void 0;
class FormulaVariableNotFoundError extends Error {
    constructor(message, variableName, variableContainer) {
        super(message);
        this.name = "FormulaVariableNotFound";
        this.data = { variableName, container: variableContainer };
    }
    getData() {
        return this.data;
    }
}
exports.FormulaVariableNotFoundError = FormulaVariableNotFoundError;
